module.exports = __webpack_public_path__ + "media/images/pages/img_gourmet_02-9997f5b23d6d9c3923556612399ff234.jpg";